import { render } from "./Juniper.vue?vue&type=template&id=2a811ecb"
import script from "./Juniper.vue?vue&type=script&lang=ts"
export * from "./Juniper.vue?vue&type=script&lang=ts"
script.render = render

export default script